import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

export const getCastleCrushInfo = createAsyncThunk(
  'CastleCrush/getCastleCrushInfo',
  async (e, store: any) => {
    // 待完善 http的返回类型
    const resp = await http.post('/live/activity/castle_pk_info', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)

export const getPkRecord = createAsyncThunk(
  'CastleCrush/getPkRecord',
  async (e, store: any) => {
    // 待完善 http的返回类型
    const resp = await http.post('/live/activity/castle_pk_record', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)

export const getPkRewardList = createAsyncThunk(
  'CastleCrush/getPkRewardList',
  async (e, store: any) => {
    // 待完善 http的返回类型
    const resp = await http.post('/live/activity/castle_pk_reward', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)

export const getPkRank = createAsyncThunk(
  'CastleCrush/getPkRank',
  async (p: {type: 1 | 2}, store: any) => {
    // 待完善 http的返回类型
    const resp = await http.post('/live/activity/castle_pk_rank', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)
export const buyCastlePkProp = createAsyncThunk(
  'CastleCrush/buyCastlePkProp',
  async (p: {prop: 1 | 2 | 3; num: number}, store: any) => {
    // 待完善 http的返回类型
    const resp = await http.post<HiyaRes<any>>('/live/activity/castle_pk_buy', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)
export const receiveCastlePkProp = createAsyncThunk(
  'CastleCrush/receiveCastlePkProp',
  async (p: {type: 1 | 2; id?: number}, store: any) => {
    // 待完善 http的返回类型
    const resp = await http.post<HiyaRes<{pic: string}>>(
      '/live/activity/castle_pk_receive',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      }
    )
    return resp.data
  }
)
export const pkPropUse = createAsyncThunk(
  'CastleCrush/pkPropUse',
  async (p: {prop: 1 | 2 | 3}, store: any) => {
    // 待完善 http的返回类型
    const resp = await http.post('/live/activity/castle_pk_use_prop', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)
// interface itemProp {
//   member_info: {
//     avatar: string
//     id: number
//     name: string
//     zy_id: string
//   }
//   rank: number
//   score: number
//   is_show?: boolean
// }
const initialState: {
  count_down: number
  coins: number // 奖池
  is_win: 0 | 1 | 2 | 3 // 0未出结果，1胜利，2失败，3平局
  family_avatar: string
  family_name: string
  protective_value: number
  people_num: number
  pk_family_avatar: string
  pk_family_name: string
  pk_protective_value: number
  pk_people_num: number
  use_fire_num: number // 使用火石的数量
  use_protect_num: number
  use_rock_num: number
  pk_use_fire_num: number
  pk_use_protect_num: number
  pk_use_rock_num: number
  fire_num: number
  protect_num: number
  rock_num: number
  prop_count_down: number // 箱子倒计时
  level: number
  score: number
  level_score: number
  todays_winner: number
  reward_list: {id: number; pic: string; text: string; is_receive: 0 | 1}[]
  rank: {
    list: {
      member_info: {
        avatar: string
        id: number
        name: string
        zy_id: string
      }
      score: number
      rank: number
    }[]
    own: {
      member_info: {
        avatar: string
        id: number
        name: string
        zy_id: string
      }
      score: number
      rank: number
    }
  }
  rewardUserList: {
    reward: {avatar: string; name: string; mid: number; coin: number}[]
    my_coin: number
  }
  status: 0 | 1 // 0正常， 1未进家族
  record: {
    is_win: 0 | 1 | 2
    avatar: string
    name: string
    pk_avatar: string
    pk_name: string
    time: string
  }[]
  activity_time: string
} = {
  count_down: 0,
  coins: 0, // 奖池
  is_win: 0, // 0未出结果，1胜利，2失败，3平局
  family_avatar: '',
  family_name: '',
  protective_value: 0,
  people_num: 0,
  pk_family_avatar: '',
  pk_family_name: '',
  pk_protective_value: 0,
  pk_people_num: 0,
  use_fire_num: 0, // 使用火石的数量
  use_protect_num: 0,
  use_rock_num: 0,
  pk_use_fire_num: 0,
  pk_use_protect_num: 0,
  pk_use_rock_num: 0,
  fire_num: 0,
  protect_num: 0,
  rock_num: 0,
  prop_count_down: 0, // 箱子倒计时
  level: 1,
  score: 0,
  level_score: 0,
  todays_winner: 0,
  reward_list: [],
  rank: {
    list: [],
    own: {} as any,
  },
  rewardUserList: {reward: [], my_coin: 0},
  status: 0,
  record: [],
  activity_time: '',
}
export const CastleCrushSlice = createSlice({
  name: 'CastleCrush',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCastleCrushInfo.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      Object.assign(state, data, {activity_time: data.activity_time.join('-')})
    })
    builder.addCase(getPkRecord.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      Object.assign(state, data)
    })
    builder.addCase(getPkRewardList.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      Object.assign(state, {rewardUserList: data})
    })
    builder.addCase(getPkRank.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      Object.assign(state, {rank: data})
    })
  },
})
export default CastleCrushSlice.reducer
